<template>
  <router-link
    :to="route"
    :class="[...colorVariant, 'inline-block align-baseline underline']"
  >
    <slot />
  </router-link>
</template>

<script>
  export default {
    name: 'BaseLink',

    props: {
      variant: {
        type: String,
        default: 'blue',
        validator: (v) => {
          return ['blue'].indexOf(v) !== -1;
        },
      },
      to: {
        type: [String, Object],
        default: '',
      },
    },

    computed: {
      colorVariant() {
        const variants = {
          blue: [
            'no-underline',
            'text-absoluteZero',
            'hover:underline',
            'active:text-black',
          ],
        };

        return variants[this.variant];
      },
      route() {
        if (typeof this.to === 'string') {
          return {
            name: this.to,
            query: this.$route.query,
          };
        }

        return this.to;
      },
    },
  };
</script>
